<template>
  <v-container fill-height align-center>
    <v-layout align-center justify-center>
      <v-flex xs12 sm8 md4>
        <v-card id="content_card">
          <v-card-title>
            <h2 style="margin: auto">Verify your E-Mail</h2>
          </v-card-title>

          <v-card-text style="margin: auto">
            Please click on the link in the E-Mail we sent you.
          </v-card-text>

          <v-card-actions>
            <v-btn v-on:click="resend_email" class="primary" block
              >Didn't receive our E-Mail?</v-btn
            >
          </v-card-actions>

          <v-alert
            :value="show_alert"
            :type="alert_type"
            transition="scale-transition"
            >{{ alert_text }}
          </v-alert>
          <v-progress-linear v-if="show_loading" :indeterminate="true" />
        </v-card> </v-flex></v-layout
  ></v-container>
</template>

<script>
/* global firebase */
export default {
  name: "Verify_Mail",
  data() {
    return {
      show_alert: false,
      alert_type: "success",
      alert_text: "",
      show_loading: false
    };
  },
  created() {
    let subscribe = this.$store.subscribe(() => {
      if (this.$store.getters["user/has_verified_mail"]) {
        subscribe();
        this.$router.push("/");
      }
    });
  },
  methods: {
    resend_email() {
      this.show_alert = false;
      this.show_loading = true;

      firebase
        .auth()
        .currentUser.sendEmailVerification()
        .then(() => {
          this.show_loading = false;
          this.alert_type = "success";
          this.alert_text = "Successfully sent E-Mail.";
          this.show_alert = true;
        })
        .catch(err => {
          this.show_loading = false;

          this.alert_text = "Could not send E-Mail";

          if (err.code === "auth/too-many-requests")
            this.alert_text = "Could not send E-Mail. Please try again later.";
          this.alert_type = "error";
          this.show_alert = true;
        });
    }
  }
};
</script>

<style scoped></style>
